import React from "react";
import { Controller } from "react-hook-form";
import { Input } from "../../shared/components/UI";
import Icon from "../../components/V2/Icon/Icon";

class InputService {
  constructor(control, errors) {
    this.control = control;
    this.errors = errors || {};
  }

  renderInput({
    name,
    type = "text",
    placeholder,
    header,
    internalOnChange = null,
    disabled = false,
    loading = false,
    ...rest
  }) {
    return (
      <div className={`input-container ${name}-input ${disabled ? "input-container-disabled" : ""} ${loading ? "input-loading" : ""}`}>
        <Controller
          name={name}
          control={this.control}
          render={({ field: { onChange, ...field } }) => (
            <Input
              {...field}
              {...rest}
              disabled={disabled}
              onChange={(e) => {
                if (disabled) return;
                onChange(e);
                if (internalOnChange) {
                  internalOnChange(e);
                }
              }}
              role="presentation"
              placeholder={placeholder}
              header={header}
              type={type}
              errors={{ [name]: this.errors?.[name]?.message || "" }}
            />
          )}
        />
        <div className="icon-container">
          {loading ? (
            <div className="input-spinner"></div>
          ) : name === "card_number" || name === "security_code" ? (
            <Icon
              name={name === "card_number" ? "card" : "padlock"}
              color="input-icon"
              width={20}
              height={name === "card_number" ? 16 : 20}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default InputService;
